var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.447 2.85a3.085 3.085 0 0 0-4.25 0 2.825 2.825 0 0 0 0 4.098l8.04 7.753 1.89-1.822a3.138 3.138 0 0 0 0-4.552l-5.68-5.477zm-7.282 3.48 15.709 15.385-4.333 4.244L5.833 10.573l4.333-4.244zm8.05 18.565-8.045-7.596-1.888 1.88c-1.302 1.297-1.302 2.92 0 4.218l5.687 5.726a3.01 3.01 0 0 0 4.245 0 2.982 2.982 0 0 0 0-4.23zm10.922-11.34a2.92 2.92 0 0 0-4.169 0 3.02 3.02 0 0 0 0 4.228l2.085 2.114 2.084-2.114a3.02 3.02 0 0 0 0-4.227zm-22.106.661-2.083-2.113-2.084 2.114a3.02 3.02 0 0 0 0 4.227 2.918 2.918 0 0 0 4.168 0 3.02 3.02 0 0 0 .001-4.227z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqr);
export default __webpack_public_path__ + "static/media/SQR.189b09725d30687f4b92113da523eb86.svg";
export { ForwardRef as ReactComponent };